import React from 'react'
import './Footer.css'

const MenuBar = () => {
    return (
        <footer >
            <div className="footer">
                <p> Copyright 2022 All Right Reserved By SG</p>
            </div>
        </footer>
    )
}

export default MenuBar;